var _linearGradient, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmagLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 133",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 4.087,
    y1: 66.626,
    x2: 496.144,
    y2: 66.626
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#ff1d25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#a0328c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#7040a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#4359c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0082e6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M438.7 55.2v27h21.7v12.7c-1.7 1-3.6 1.7-5.8 2.2-2.2.5-5.1.7-8.7.7-4.5 0-8.5-.7-12.2-2.2-3.7-1.4-6.9-3.5-9.5-6.2-2.7-2.7-4.7-5.9-6.2-9.6-1.5-3.7-2.3-7.8-2.3-12.3v-.4c0-4.3.7-8.3 2.1-12 1.4-3.6 3.4-6.8 5.9-9.4 2.5-2.7 5.6-4.7 9.1-6.2s7.3-2.3 11.4-2.3c5.3 0 10.3 1 14.9 2.9s9 4.6 13.2 8.2L496 19.7c-6.9-6-14.7-10.8-23.5-14.1-8.8-3.4-18.6-5.1-29.6-5.1-10 0-19.3 1.7-27.8 5s-15.9 7.9-22.2 13.9c-6.3 5.9-11.2 12.9-14.7 21-3.1 7.1-4.8 14.8-5.2 22.9l-25.5-61h-42l-36.2 86.6V3.2H225l-27.2 44.6-27.1-44.6h-44.2v28.4c-2.1-3.8-4.6-7.3-7.4-10.5-5.6-6.3-12.6-11.3-21.1-15C89.5 2.4 79.4.5 67.9.5c-9.9 0-19 1.7-27.3 5.1-8.3 3.4-15.5 8.1-21.5 14.1s-10.7 13-14 21c-3.3 8-5 16.6-5 25.8v.5c0 9.8 1.8 18.8 5.3 26.9 3.6 8.1 8.5 15 14.9 20.7 6.4 5.7 13.9 10.1 22.7 13.3 8.8 3.2 18.4 4.8 29 4.8 13.4 0 24.9-2.3 34.4-7 4.7-2.3 8.9-5 12.8-8L97.9 91.9c-2.6 1.9-5.3 3.4-7.9 4.5-4.7 2-9.9 3-15.5 3-7.4 0-13.7-1.7-18.7-5.1-4.2-2.9-7.3-7-9.3-12.4h79.9V130h41.3V67.2l29.3 45.1h.7L227 67.2v62.9h70.3l6.5-17h44.4l6.7 17h46l-6-14.3c6.2 5.3 13.3 9.4 21.4 12.3 8.6 3.1 17.9 4.7 27.8 4.7 11.6 0 22.1-1.7 31.5-5.2 9.4-3.5 17.6-8.1 24.5-13.7V55.2h-61.4zM45 55.1c1.4-6.5 3.9-11.8 7.7-15.7 4-4.1 9.1-6.2 15.4-6.2 6.4 0 11.7 2.1 15.9 6.2 3.9 3.9 6.4 9.2 7.3 15.7H45zM314.5 83l11.6-30.8L337.7 83h-23.2z",
    fill: "url(#a)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmagLogo);
export default __webpack_public_path__ + "static/media/emag-logo.9e1b682d44ae0772e206183c225315e5.svg";
export { ForwardRef as ReactComponent };